// extracted by mini-css-extract-plugin
export default {"container":"ls-z","heading":"ms-z","text":"ns-z","info":"os-z","link":"ps-z","fullMaxWidth":"qs-z"};